import { supabase } from './supabase';

// Suggestion only — the caller must show these as editable, unconfirmed
// fields (never auto-save), same as describeMedicine. See docs/AI_RULES.md.
//
// Unlike describeMedicine (name only), this sends the actual package photo
// to Anthropic via the analyze-medicine-photo Edge Function — a deliberate,
// user-requested exception to the app's "photo never leaves the device"
// default. See docs/PRIVACY.md.
export interface PhotoAnalysis {
  nameGuess?: string;
  expiryIso?: string;
  expiryHint?: string;
  dosage?: string;
  quantityEstimate?: number;
  quantityBasis?: 'label' | 'visual_count';
  note?: string;
}

export async function analyzeMedicinePhoto(photoDataUrl: string, model: string): Promise<PhotoAnalysis> {
  if (!supabase) throw new Error('Supabase не настроен');
  const { data, error } = await supabase.functions.invoke('analyze-medicine-photo', {
    body: { photo: photoDataUrl, model },
  });
  if (error) {
    let message = error.message;
    if ('context' in error && error.context instanceof Response) {
      try {
        const body = await error.context.clone().json();
        if (body?.error) message = body.error;
      } catch {
        // ignore — fall back to the generic error.message
      }
    }
    throw new Error(message);
  }
  return data as PhotoAnalysis;
}
